// const BASE_URL_API3 = 'http://10.12.1.29:9008';
const BASE_URL_API = process.env.REACT_APP_BASE_URL_API;
const BASE_URL_API_PRINT = process.env.REACT_APP_BASE_URL_API_PRINT;
const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;
const API_VERSION = process.env.REACT_APP_API_VERSION;
const API_VERSION2 = process.env.REACT_APP_API_VERSION2;
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
const QZ_ENC_PRIVATE_KEY = process.env.REACT_APP_QZ_ENC_PRIVATE_KEY;
const QZ_ENC_CERTIFICATE_KEY = process.env.REACT_APP_QZ_ENC_CERTIFICATE_KEY;
const PRINT_LOGO = process.env.REACT_APP_PRINT_LOGO;
const PRINTER_CONFIG = process.env.REACT_APP_PRINTER_CONFIG;

export default {
  BASE_URL_API,
  BASE_URL_IMG,
  API_VERSION,
  API_VERSION2,
  BASE_URL_API_PRINT,
  ENCRYPTION_KEY,
  QZ_ENC_CERTIFICATE_KEY,
  QZ_ENC_PRIVATE_KEY,
  PRINT_LOGO,
  PRINTER_CONFIG,
};
